import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { acceptInvite } from "../api/members";
import { useAuth } from "../providers/AuthContext";


const AcceptInvite = () => {
  const [searchParams] = useSearchParams();
  const invite_token = searchParams.get("token");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { login, logout, isLoggedIn } = useAuth();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [wrongUser, setWrongUser] = useState(false);

  // Якщо юзер вже залогінений — приймаємо інвайт одразу без пароля
  useEffect(() => {
    if (isLoggedIn && invite_token) {
      (async () => {
        try {
          await acceptInvite({ invite_token });
          navigate("/dashboard");
        } catch (err) {
          setWrongUser(true);
        }
      })();
    }
  }, [isLoggedIn, invite_token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError(t('accept_invite.passwords_mismatch'));
      return;
    }
    setLoading(true);
    setError("");
    try {
      const data = await acceptInvite({ invite_token, password });
      await login(data.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || t('accept_invite.error'));
    } finally {
      setLoading(false);
    }
  };

  if (!invite_token) {
    return <p style={{ padding: 32 }}>{t('accept_invite.invalid_link')}</p>;
  }

  if (wrongUser) {
    return (
      <div style={{ maxWidth: 400, margin: "80px auto", padding: "0 16px" }}>
        <h2 style={{ marginBottom: 8 }}>{t('accept_invite.title')}</h2>
        <p style={{ color: "#ef4444", fontSize: 14, marginBottom: 16 }}>
          {t('accept_invite.wrong_user')}
        </p>
        <button
          className="button"
          onClick={() => { logout(); }}
          style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}
        >
          {t('accept_invite.logout_and_accept')}
        </button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 400, margin: "80px auto", padding: "0 16px" }}>
      <h2 style={{ marginBottom: 8 }}>{t('accept_invite.title')}</h2>
      <p style={{ marginBottom: 8, color: "#6b7280" }}>
        {t('accept_invite.subtitle')}
      </p>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
        <TextField
          type="password"
          label={t('common.password')}
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          slotProps={{ input: { minLength: 6 } }}
          fullWidth
          margin="normal"
        />
        <TextField
          type="password"
          label={t('accept_invite.confirm_password')}
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          required
          fullWidth
          margin="normal"
        />
        {error && <p style={{ color: "#ef4444", fontSize: 14, margin: "8px 0 0" }}>{error}</p>}
        <button type="submit" className="button" disabled={loading} style={{ marginTop: 24, backgroundColor: "var(--primary-color)", color: "#fff" }}>
          {loading ? t('common.loading') : t('accept_invite.submit')}
        </button>
      </form>
    </div>
  );
};

export default AcceptInvite;
